export default "__VITE_ASSET__DQOIHPwB__"